export var SmartphotoExternalEstimationStatus;
(function (SmartphotoExternalEstimationStatus) {
    SmartphotoExternalEstimationStatus["NOT_READY"] = "not_ready";
    SmartphotoExternalEstimationStatus["READY"] = "ready";
    SmartphotoExternalEstimationStatus["ERRORED"] = "errored";
})(SmartphotoExternalEstimationStatus || (SmartphotoExternalEstimationStatus = {}));
